

import {Injectable} from '@angular/core';
import {EFieldType} from '../../../form-builder/enums/e-field-type.enum';
import {DateFieldService} from '../date-field/date-field.service';
import {FieldValue} from '../../../form-renderer/interfaces/FieldValue';
import {SelectFieldService} from '../select-field/select-field.service';

@Injectable()

export class FieldValueService {

  constructor(private dateService: DateFieldService, private selectService: SelectFieldService) {
  }

  /**
   *
   * @param {FieldValue} fieldValue
   * @returns {Promise<string>}
   */
  private getYesAndNoValue(fieldValue: FieldValue): Promise<string> {

    if (fieldValue.yes_no_value == null)
      return Promise.resolve(' ');
    else if (fieldValue.yes_no_value)
      return Promise.resolve('Yes');

    else return Promise.resolve('No')
  }

  public getFieldValue(fieldValue: FieldValue): Promise<string> {

    switch (fieldValue.field.type) {
      case EFieldType.DATE:
        if (fieldValue.date_value == null)
          return Promise.resolve('');
        return Promise.resolve(String(fieldValue.date_value));
      case EFieldType.DROPDOWN:
       return this.selectService.getSelectValue(fieldValue);
      case EFieldType.TEXT:
        if (fieldValue.string_value == null)
          return Promise.resolve('');
        return Promise.resolve(String(fieldValue.string_value));
      case EFieldType.DECIMAL:
        if (fieldValue.decimal_value == null)
          return Promise.resolve('');
        return Promise.resolve(String(fieldValue.decimal_value));
      case EFieldType.CHECKBOX:
        if (fieldValue.check_value == null)
          return Promise.resolve('');
        return Promise.resolve(String(fieldValue.check_value));
      case EFieldType.INTEGER:
        if (fieldValue.int_value == null)
          return Promise.resolve('');
        return Promise.resolve(String(fieldValue.int_value));
      case EFieldType.TIMESTAMP:
        if (fieldValue.timestamp_value == null)
          return Promise.resolve('');
        return Promise.resolve(String(fieldValue.timestamp_value));
      case EFieldType.YES_NO:
        return this.getYesAndNoValue(fieldValue);
      default:
        return Promise.resolve('');
    }
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/fields/services/field-value/field-value.service.ts